module.exports = __webpack_public_path__ + "static/6968660_orig-6992083a5e25abd78466fa0641de2d54.jpg";